<template>
  <v-card flat dark class="grey darken-2 pa-4">
    <v-text-field solo class="font-italic" v-model="title" label="Hey, What's up"></v-text-field>
    <v-textarea solo counter label="Say more about it? Guest's post will be reviewed to be displayed." v-model="content"></v-textarea>
    <v-btn dark color="indigo lighten-2" :disabled="!valid" @click="handlePost">Post</v-btn>
  </v-card>
</template>

<script>
import { createPost } from '../../api/auth';
import { bus } from '../../main';

export default {
  data() {
    return {
      title:'',
      content:'',
    }
  },
  computed:{
    valid() {
      return this.title.length >=2 && this.content.length > 2;
    }
  },
  methods: {
    async handlePost() {
      let userId = 'guest';
      let published = 0;
      let sort = 20;
      if(this.$store.getters['isLoggedIn']) {
        userId = this.$store.getters['getProfile'].userId;
        published = 1;
        sort = 10
      }
      let newPost = {
        title: this.title,
        content: this.content,
        userId,
        published,
        sort
      }
      const res = await createPost(newPost);
      if(res.status == '1') {
        this.title = '';
        this.content = '';
        this.$toast({ text: `Posted`, btnText: `${ this.$t('closeBtn') }` });
        bus.$emit('newPost');
      }
    }
  }
}
</script>

<style>

</style>